module.exports = __webpack_public_path__ + "img/logo_blue.2085fb73.png";